const checkIfValidUrl = (url) => /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#:.?+=&%@!\-/]))?/.test(url);
export default checkIfValidUrl;
//# sourceMappingURL=index.js.map